/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Profilesidebar from "../Element/Profilesidebar";
import Profilepic from "./../../images/team/pic1.jpg";
import BaseUrl from "../../BaseUrl";
import { useSelector } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";
import { useCallback } from "react";
import { TagsInput } from "react-tag-input-component";

function Profile() {
  const token = useSelector((state) => state.auth.auth);
  const [category, setcategory] = useState([]);
  const [skills, setskills] = useState([]);
  const [subcategory, setsubcategory] = useState([]);
  const [sub_category_id, setsub_category_id] = useState([]);
  
  const [loader, setLoader] = useState(false);
  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [professtitle, setprofesstitle] = useState("");
  const [language, setlanguage] = useState("");
  const [age, setage] = useState("");
  const [qualifications, setqualifications] = useState([]);
  // const [subqualification, setsubqualification] = useState("");
  const [certifications, setcertifications] = useState([]);
  const [work_experiences, setwork_experiences] = useState([]);
  const [description, setdescription] = useState("");
  const [phonenumber, setphonenumber] = useState("");
  const [emailaddress, setemailaddress] = useState("");
  const [country, setcountry] = useState("");
  const [postcode, setpostcode] = useState("");
  const [city, setcity] = useState("");
  const [address, setaddress] = useState("");
  const [img] = useState("");
  const [imgs, setimgs] = useState("");
  const [, setFielderr] = useState("");
  const [getprofile, setGetprofile] = useState("");
  const [imgpath, setImgpath] = useState("");
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    setimgs(file);
  };

  const onGet = useCallback(async () => {
    setLoader(true);
    var config = {
      method: "get",
      url: `${BaseUrl.baseurl}/user/profile/view`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token.token}`,
      },
    };

    await axios(config)
      .then(function (response) {
        setLoader(false);

        setImgpath(response?.data?.imagepath);
        console.log(response?.data?.user);
        setGetprofile(response?.data?.user);
        setskills(response?.data?.user?.skills?.map((data) => data.name));
        setqualifications(response?.data?.user?.qualifications?.map((data) => data.name));
        setcertifications(response?.data?.user?.certifications?.map((data) => data.name));
        setwork_experiences(response?.data?.user?.work_experiences?.map((data) => data.name));
        if (response?.data?.status === true) {
          setLoader(false);

          Swal.fire({
            showCloseButton: true,
            toast: true,
            icon: "success",
            title: response?.data?.message,
            animation: true,
            position: "top-right",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          setLoader(false);
          console.log(response);
        }
      })
      .catch(function (error) {
        setLoader(false);

        console.log(error?.response);
        setFielderr(error?.response?.data?.errors);
        Swal.fire({
          showCloseButton: true,
          toast: true,
          icon: "error",
          title: error?.response?.data?.errors.map((e) => e),
          animation: true,
          position: "top-right",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      });
  }, [token.token]);
  console.log(skills, "skills");

  useEffect(() => {
    onGet();
  }, [onGet]);
  const onSubmit = () => {
    const Submit = new FormData();
    Submit.append("first_name", firstname ? firstname : getprofile?.first_name);
    Submit.append("last_name", lastname ? lastname : getprofile?.last_name);
    // eslint-disable-next-line no-unused-expressions
    skills?.map((data, index) => Submit.append(`skills[${index}]`, data));
    Submit.append("last_name", lastname ? lastname : getprofile?.last_name);
    Submit.append(
      "sub_category_id",
      sub_category_id ? sub_category_id : getprofile?.sub_category?.id
    );
    Submit.append(
      "category_id",
      professtitle ? professtitle : getprofile?.category?.id
    );
    Submit.append("language", language ? language : getprofile?.language);
    Submit.append("age", age ? age : getprofile?.age);
    qualifications.map((val, ind) => Submit.append(`qualifications[${ind}]`, val))
    certifications.map((val, ind) => Submit.append(`certifications[${ind}]`, val))
    work_experiences.map((val, ind) => Submit.append(`work_experiences[${ind}]`, val))
    // Submit.append(
    //   "qualifications", qualifications
 
    //   // ? qualification : getprofile?.qualification
    // );
    // qualification?.map((data, index) => Submit.append(`qualification[${index}]`, data));
    // Submit.append(
    //   "certification",
    //   certification ? certification : getprofile?.certification
    // );
    Submit.append(
      "description",
      description ? description : getprofile?.description
    );
    Submit.append("address", address ? address : getprofile?.address);
    Submit.append(
      "phone_number",
      phonenumber ? phonenumber : getprofile?.phone_number
    );
    Submit.append("email", emailaddress ? emailaddress : getprofile?.email);
    Submit.append("country", country ? country : getprofile?.country);
    Submit.append("postcode", postcode ? postcode : getprofile?.postcode);
    Submit.append("city", city ? city : getprofile?.city);
    Submit.append("image", imgs);

    setLoader(true);
    var config = {
      method: "post",
      url: `${BaseUrl.baseurl}/user/profile/update`,
      data: Submit,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token.token}`,
      },
    };

    axios(config)
      .then(function (response) {
        onGet();
        if (response?.data?.status === true) {
          setLoader(false);
          Swal.fire({
            showCloseButton: true,
            toast: true,
            icon: "success",
            title: response?.data?.message,
            animation: true,
            position: "top-right",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        setimgs();
        console.log(error);
        setFielderr(error?.response?.data?.errors);
        Swal.fire({
          showCloseButton: true,
          toast: true,
          icon: "error",
          title: error?.response?.data?.message,
          animation: true,
          position: "top-right",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      });
  };
  useEffect(() => {
    handleGetcategory();
  }, []);

  const handlecategory = (e) => {
    const { value } = e.target;
    setprofesstitle(value);
    var config = {
      method: "get",
      url: `${BaseUrl.baseurl}/subcategory/${value}`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token.token}`,
      },
    };

    axios(config)
      .then((res) => {
        setsubcategory(res?.data?.subcategory);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleGetcategory = () => {
    var config = {
      method: "get",
      url: `${BaseUrl.baseurl}/category/view`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token.token}`,
      },
    };

    axios(config)
      .then((res) => {
        setcategory(res?.data?.category);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      {loader ? <div className="loader"></div> : null}
      <Header />
      <div className="page-content bg-white">
        <div className="content-block">
          <div className="section-full bg-white browse-job p-t50 p-b20">
            <div className="container">
              <div className="row">
                <Profilesidebar
                  value={
                    img
                      ? img
                      : getprofile?.image
                      ? imgpath + getprofile?.image
                      : Profilepic
                  }
                  Change={handleImageUpload}
                  Name={getprofile?.first_name + " " + getprofile?.last_name}
                  title={getprofile?.professional_title}
                />
                <div className="col-xl-9 col-lg-8 m-b30">
                  <div className="job-bx job-profile">
                    <div className="job-bx-title clearfix">
                      <h5 className="font-weight-700 pull-left text-uppercase">
                        Update Profile
                      </h5>
                      <Link
                        to={"/"}
                        className="site-button right-arrow button-sm float-right"
                      >
                        Back
                      </Link>
                    </div>
                    <form>
                      <div className="row m-b30">
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>First Name:</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={getprofile?.first_name}
                              onChange={(e) => {
                                setfirstname(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>Last Name:</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={getprofile?.last_name}
                              onChange={(e) => {
                                setlastname(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>Professional title:</label>
                            <select
                              type="text"
                              className="form-control search-slt"
                              name=""
                              placeholder="Professional"
                              onChange={handlecategory}
                            >
                              <option selected disabled>
                                 {getprofile?.category?.id ? getprofile?.category?.name :'Select Your Professional'  } 
                              </option>
                              {category?.map((item) => (
                                <option key={item.id} value={item?.id}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>Professional Sub title:</label>
                            <select
                              type="text"
                              className="form-control search-slt"
                              name=""
                              placeholder="Professional"
                              onChange={(e) =>
                                setsub_category_id(e.target.value)
                              }
                            >
                              <option selected disabled>
                              {getprofile?.sub_category?.id ? getprofile?.sub_category?.name :'Select Your Professional'  } 
                              </option>
                              {subcategory?.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>Languages:</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={getprofile?.language}
                              onChange={(e) => {
                                setlanguage(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>Age:</label>
                            <input
                              defaultValue={getprofile?.age}
                              type="number"
                              className="form-control"
                              onChange={(e) => {
                                setage(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        {/* <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>Qualification:</label>
                            <input
                              defaultValue={getprofile?.qualification}
                              type="text"
                              className="form-control"
                              onChange={(e) => {
                                setqualification(e.target.value);
                              }}
                            />
                          </div>
                        </div> */}
                        {/* <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>Certification:</label>
                            <input
                              defaultValue={getprofile?.certification}
                              type="text"
                              className="form-control"
                              onChange={(e) => {
                                setcertification(e.target.value);
                              }}
                            />
                          </div>
                        </div> */}
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <label>Skills:</label>
                            <TagsInput
                              value={skills}
                              onChange={setskills}
                            
                              placeHolder="enter your qualification"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <label>Qualification:</label>
                            <TagsInput
                              value={qualifications}
                              onChange={setqualifications}
                              placeHolder="enter your skills"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <label>Certification:</label>
                            <TagsInput
                              value={certifications}
                              onChange={setcertifications}
                              placeHolder="enter your certifications"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <label>Work Experience:</label>
                            <TagsInput
                              value={work_experiences}
                              onChange={setwork_experiences}
                              placeHolder="enter your work experiences"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <label>Description:</label>
                            <textarea
                              defaultValue={getprofile?.description}
                              className="form-control"
                              onChange={(e) => {
                                setdescription(e.target.value);
                              }}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div className="job-bx-title clearfix">
                        <h5 className="font-weight-700 pull-left text-uppercase">
                          Contact Information
                        </h5>
                      </div>
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>Phone:</label>
                            <input
                              defaultValue={getprofile?.phone_number}
                              type="tel"
                              className="form-control"
                              onChange={(e) => {
                                setphonenumber(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>Email Address:</label>
                            <input
                              defaultValue={getprofile?.email}
                              type="email"
                              className="form-control"
                              onChange={(e) => {
                                setemailaddress(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>Country:</label>
                            <input
                              defaultValue={getprofile?.country}
                              type="text"
                              className="form-control"
                              onChange={(e) => {
                                setcountry(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>Postcode:</label>
                            <input
                              defaultValue={getprofile?.postcode}
                              type="tel"
                              className="form-control"
                              onChange={(e) => {
                                setpostcode(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>City:</label>
                            <input
                              defaultValue={getprofile?.city}
                              type="text"
                              className="form-control"
                              onChange={(e) => {
                                setcity(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label>Full Address:</label>
                            <input
                              defaultValue={getprofile?.address}
                              type="text"
                              className="form-control"
                              onChange={(e) => {
                                setaddress(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="site-button m-b30"
                        type="button"
                        onClick={onSubmit}
                      >
                        Save Changes
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default Profile;
